import { Vec, type Editor, type TLLineShape, type TLShapeId } from "tldraw";

/**
 * Where a binding's anchor lands in page space, shared by every annotation
 * that pins an end to a shape (dims and callout leaders). A polyline vertex
 * binding resolves to that exact point, so edits to unrelated vertices
 * cannot drag it; everything else resolves to the anchor on the target's
 * bounds. Null when the target is gone, which leaves the annotation on the
 * free point it last resolved to.
 */
export function boundAnchorPage(
  editor: Editor,
  binding: {
    toId: TLShapeId;
    props: { anchor: { x: number; y: number }; vertex?: string };
  },
): Vec | null {
  if (binding.props.vertex) {
    const target = editor.getShape(binding.toId);
    const point =
      target?.type === "line"
        ? (target as TLLineShape).props.points[binding.props.vertex]
        : undefined;
    if (point) {
      return Vec.From(
        editor.getShapePageTransform(binding.toId).applyToPoint(point),
      );
    }
  }
  const bounds = editor.getShapePageBounds(binding.toId);
  if (!bounds) return null;
  return new Vec(
    bounds.x + binding.props.anchor.x * bounds.w,
    bounds.y + binding.props.anchor.y * bounds.h,
  );
}
